import React from 'react';
import { Link } from 'react-router-dom';
import moment from 'moment';
import 'moment/locale/hr';

const AssetsList = props => (
  <section>
    <div className="container">
      <div className="row">
        <div className="col-12 text-center ">
          {/* <h1 className="">{props.clanovi.title}</h1> */}
          <div className="u-h-4 u-w-50 bg-white rounded mx-auto my-4" />
        </div>
      </div>
      <div className="row align-items-center ">
        {props.assetsList.map(({ id, name, preview, added }) => (
          <Link className="col-lg-4 text-center mt-4" key={id} to={`/asset/${id}`}>
            <img className="w-100 rounded box-shadow-v1" src={preview} alt={name} />
            <div className="my-md-4">
              <h4 className="mb-0">{name}</h4>
              {/* <h4 className="mb-0">{added.toDate()}</h4> */}
              {moment(added.toDate()).fromNow()}
              <p className="my-4" />
            </div>
          </Link>
        ))}
        <Link className="col-lg-4 text-center mt-4" to="/assets/add">
          <img
            className="w-100 rounded box-shadow-v1"
            src="https://storage.googleapis.com/assets.vespaklubrijeka.com/placeholder-bw.jpg"
            alt="Novi asset"
          />
          <div className="my-md-4">
            <h4 className="mb-0">DODAJ NOVI ASSET</h4>
            <p className="my-4" />
          </div>
        </Link>
      </div>
    </div>
  </section>
);

export default AssetsList;



// WEBPACK FOOTER //
// ./src/components/AssetsList.js